import type React from 'react';

const TimelinePointMarker: React.FC = () => {
  return (
    <div className="absolute top-1.5 left-1 bg-white rounded-full h-3 w-3" />
  );
};

export default TimelinePointMarker;
